module.exports = __webpack_public_path__ + "static/media/Step6.6d706884.png";